import React from 'react';
import { List, Datagrid, EditButton, TextInput, BooleanInput, Filter } from 'react-admin';

import { LookupFields } from '../customFields';

const DeviceTypeFilter = (props) => (
	<Filter {...props}>
		<TextInput source="name" alwaysOn />
		<BooleanInput source="active" alwaysOn />
	</Filter>
);

const DeviceTypeDataGrid = (props) => (
	<Datagrid rowClick="show" {...props}>
		{LookupFields(props)}
		<EditButton />
	</Datagrid>
);

const DeviceTypeList = (props) => (
	<List
		filters={<DeviceTypeFilter />}
		filterDefaultValues={{ active: true }}
		sort={{ field: 'createdAt', order: 'DESC' }}
		bulkActionButtons={false}
		{...props}
	>
		<DeviceTypeDataGrid />
	</List>
);

export default DeviceTypeList;
